import type { ChatServerTheme } from "../types";

const KEY_PREFIX = "nexor.chat.theme.";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

interface Entry {
  t: number;
  theme: ChatServerTheme;
}

export function readCachedTheme(workflowId: string): ChatServerTheme | undefined {
  try {
    const raw = window.localStorage.getItem(KEY_PREFIX + workflowId);
    if (!raw) return undefined;
    const entry = JSON.parse(raw) as Entry;
    if (!entry?.theme || typeof entry.t !== "number") return undefined;
    if (Date.now() - entry.t > MAX_AGE_MS) return undefined;
    return entry.theme;
  } catch {
    return undefined;
  }
}

export function writeCachedTheme(workflowId: string, theme: ChatServerTheme | undefined): void {
  try {
    if (!theme) return;
    window.localStorage.setItem(
      KEY_PREFIX + workflowId,
      JSON.stringify({ t: Date.now(), theme } satisfies Entry),
    );
  } catch {
    return;
  }
}
